import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

/**
 * Tracks the count of in-flight non-GET HTTP requests so features like
 * auto-update can defer a reload until the user's pending writes have
 * settled. GETs are excluded — losing an in-flight read to a reload is
 * harmless, losing a POST/PATCH/PUT/DELETE is not.
 */
@Injectable({ providedIn: 'root' })
export class InFlightInterceptor implements HttpInterceptor {
  private readonly count$ = new BehaviorSubject<number>(0);

  get pendingMutations$(): Observable<number> {
    return this.count$.asObservable();
  }

  get currentPendingMutations(): number {
    return this.count$.value;
  }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.method === 'GET' || req.method === 'HEAD' || req.method === 'OPTIONS') {
      return next.handle(req);
    }
    this.count$.next(this.count$.value + 1);
    return next.handle(req).pipe(
      finalize(() => this.count$.next(Math.max(0, this.count$.value - 1))),
    );
  }
}
